import { Component, OnInit, ViewChild } from '@angular/core';
import { People, PeopleAdapter } from '../models/people';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PeoplesService } from '../services/peoples.service';
import { map, Observable } from 'rxjs';
// import { EventsService } from '../services/events.service';
// import { Event, EventAdapter } from '../models/event';
import { RouterModule } from '@angular/router';
import { TeamAssignationModalComponent } from '../team-assignation-modal/team-assignation-modal.component';
import { Team, TeamAdapter } from '../models/team';
import { ITeamAllocation } from '../_interfaces/teamAllocation';
import { TranslatePipe } from '@ngx-translate/core';
import { PeopleAddModalComponent } from '../people-add-modal/people-add-modal.component';
import { AvatarComponent } from "../_utils/components/avatar/avatar.component";
import { PeopleStatusComponent } from '../_utils/components/people-status/people-status.component';
import { ToastService } from '../services/toast.service';
import { EventsComponent } from '../_utils/components/events/events.component';

@Component({
  selector: 'app-people',
  standalone: true,
  imports: [CommonModule, RouterModule, TeamAssignationModalComponent, TranslatePipe, PeopleAddModalComponent, AvatarComponent, PeopleStatusComponent, EventsComponent],
  templateUrl: './people.component.html',
  styleUrl: './people.component.scss'
})
export class PeopleComponent implements OnInit {
  @ViewChild('eventsComponent') eventsComponent!: EventsComponent;
  person: People = new People(); 
  showTeamAssignationModal: boolean = false;
  showEditPersonModal: boolean = false;
  private peopleObservable!: Observable<People>;
  private personId: number = 0;


  constructor(
    private route: ActivatedRoute,
    private peoplesService: PeoplesService,
    private peopleAdapter: PeopleAdapter,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.personId = this.route.snapshot.params['id'];
    this.fecthPerson();
  }

  fecthPerson() {
    this.peopleObservable = this.peoplesService.get_people(this.personId).pipe(
      map(this.peopleAdapter.adapt)
    );

    this.peopleObservable.subscribe((res: People) => {
      this.person = res;
    });
  }


  openTeamAssignationModal(person: People): void {
    this.person = person; 
    this.showTeamAssignationModal = true; 
  }

  editTeamAssignation(updatedTeams: ITeamAllocation[] | undefined): void {
    this.showTeamAssignationModal = false;

    if (updatedTeams !== undefined) {
      this.fecthPerson();
      this.eventsComponent.reloadEvents();
      this.toastService.showSuccess('COMMON.UPDATE_SUCCESS');
    } else {
      console.log('Modale closed wihthout changes.');
    }
  }

  openEditPersonModal(person: People): void {
    this.person = { ...person };
    this.showEditPersonModal = true;
  }

  editPerson(person?: People): void {
    if (person) {
      this.peoplesService.update_people(this.peopleAdapter.adaptToApi(person)).subscribe({
        next: (updatedPerson: People) => {
          this.person = this.peopleAdapter.adapt(updatedPerson);
          this.showEditPersonModal = false;
          this.eventsComponent.reloadEvents();
          this.toastService.showSuccess('COMMON.UPDATE_SUCCESS');
        },
        error: (err) => {
          console.error('Error during person update', err);
          this.showEditPersonModal = false;
          this.toastService.showSuccess('COMMON.UPDATE_ERROR');
        }
      });
    } else {
      // closing the modal without changes
      this.showEditPersonModal = false;
    }
  }

  getAllocationRateClass(): string {
    const rate = this.person.total_allocation_rate || 0;
    if (rate >= 90) {
      return 'alert-success border-success text-success'; // Vert
    } else if (rate < 50 || rate > 100) {
      return 'alert-danger border-danger text-danger'; // Rouge
    } else if (rate >= 50 && rate <= 90) {
      return 'alert-warning border-warning text-warning'; // Jaune
    } else {
      return 'alert-primary border-primary text-primary'; // Bleu (pour 91-99%)
    }
  }
  
}
